import { RenderEvent } from 'core';
import React from 'react';


export class InSearch extends React.Component<{event:RenderEvent,$id:string}>{
    render(){
        return this.props.children || null;
    }
}